import { withTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    fetchMenuStructure,
    setIsBannerShown,
} from '../../app-state/slices/AppDataSlice';
import { setIsSessionValid, setUser } from '../../app-state/slices/AuthSlice';
import { AppDispatch, RootState } from '../../app-state/store';
import { restoreSession as AuthRestoreSession } from '../../canopy-ui-components/api/auth';
import SpinnerOverlay from '../../canopy-ui-components/components/SpinnerOverlay/SpinnerOverlay';
import { clearLocalStorage } from '../../canopy-ui-components/helpers/localStorage';
import { useGetDeviceType } from '../../canopy-ui-components/hooks/UseResponsive/UseResponsive';
import appConfig from '../../config/app';
function AuthWrapper({ t, children }: any) {
    const deviceType = useGetDeviceType();
    const dispatch = useDispatch<AppDispatch>();
    const router = useNavigate();

    const location = useLocation();
    const {
        appData: {
            menuStructure: { homePageUrl },
        },
        auth: { logoutStatus, isSessionValid },
    } = useSelector((state: RootState) => state);
    const restoreSession = async () => {
        try {
            const response = await AuthRestoreSession();
            dispatch(setIsSessionValid(true));
            dispatch(setUser(response));

            !homePageUrl &&
                deviceType &&
                dispatch(fetchMenuStructure({ deviceType }));
        } catch (e) {
            dispatch(setIsSessionValid(false));
        }
    };

    const handleRedirection = async () => {
        if (location?.pathname === '/') {
            if (isSessionValid && homePageUrl) {
                router(homePageUrl);
            } else {
                router('/login');
            }
            return;
        }
        await restoreSession();
    };

    useEffect(() => {
        (async () => {
            await handleRedirection();
        })();
    }, [deviceType]);

    useEffect(() => {
        (async () => {
            await handleRedirection();
        })();
    }, [location?.pathname]);

    useEffect(() => {
        if (isSessionValid === false) {
            if (location.pathname !== '/login') {
                router('/login');
            }
        } else if (isSessionValid === true) {
            if (location.pathname === '/login' && homePageUrl) {
                router(homePageUrl);
            }
        }
    }, [isSessionValid]);

    useEffect(() => {
        if (!deviceType) {
            return;
        }
        if (isSessionValid && homePageUrl && location.pathname === '/login') {
            router(homePageUrl);
            return;
        }
        // This condition is required to handle navigation after the login button click
        if (homePageUrl && !isSessionValid) {
            restoreSession();
        }
    }, [homePageUrl, deviceType]);

    useEffect(() => {
        if (logoutStatus === 'success' || logoutStatus === 'error') {
            clearLocalStorage();
            dispatch(setIsBannerShown(null));
            if (appConfig?.basePath) {
                window.location.href = '/';
                return;
            }
            if (location.pathname !== '/login') {
                router('/login');
            } else {
                router(0);
            }
        }
    }, [logoutStatus]);

    if (logoutStatus === 'loading') {
        return <SpinnerOverlay text={t('logging-you-out')}></SpinnerOverlay>;
    }
    if (
        (isSessionValid === false && location?.pathname === '/login') ||
        (isSessionValid === true &&
            homePageUrl &&
            location?.pathname !== '/login')
    ) {
        return children;
    }

    return <SpinnerOverlay text={t('loading')}></SpinnerOverlay>;
}

AuthWrapper.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('translations')(AuthWrapper);
